import KFullscreenDialog from "./KFullscreenDialog";
import KGoogleAutocomplete from "./KGoogleAutocomplete";
import KGooglePlacesTextSearch from "./KGooglePlacesTextSearch";
import { Geocodable } from "kinnect-mixins";
import { VBtn, VIcon } from "vuetify/lib";

export default {
	name: "KAddressField",

	mixins: [ Geocodable ],

	props: {
		address: String,
		city: String,
		label: {
			default: "Address Search",
			type: String
		},
		state: String,
		title: {
			default: "Select Address",
			type: String
		},
		zip: [ Number, String ],
		value: String
	},

	data: () => ( {
		addressSearch: null,
		geocoder: null,
		map: {
			isOpen: false,
			center: {
				lat: 36.115614,
				lng: -97.049664
			},
			markerCoords: null,
			options: {
				gestureHandling: "greedy"
			},
			place: null,
			search: null,
			infoWindow: {
				address: null,
				isOpen: false,
				options: {
					maxWidth: 400,
					pixelOffset: {
						height: -37,
						width: 0
					}
				}
			}
		},
		searchPlace: null
	} ),

	computed: {
		locationToGeocode() {
			return this.map.markerCoords;
		},

		infoWindowTitle() {
			if ( this.geocoderRunning ) {
				return "Loading...";
			} else if ( this.geocodedLocation ) {
				return this.geocodedLocation.name;
			}

			return null;
		}
	},

	watch: {
		"map.isOpen"( val ) {
			if ( val ) {
				this.$gmapDefaultResizeBus.$emit( "resize" );
			}
		},

		"map.markerCoords"( val ) {
			this.geocode();
			this.map.infoWindow.isOpen = true;
			this.$refs.addressMap.panTo( val );
		},

		addressSearch( val ) {
			this.$emit( "input", val );
		},

		searchPlace( val ) {
			this.$emit( "placechanged", val );
			this.$emit( "update:address", [ val.street_number, val.route ].join( " " ) );
			this.$emit( "update:city", val.locality || null );
			this.$emit( "update:lat", val.latitude || null );
			this.$emit( "update:lng", val.longitude || null );
			this.$emit( "update:state", val.administrative_area_level_1 || null );
			this.$emit( "update:zip", val.postal_code || null );
		}
	},

	methods: {
		useMapAddress() {
			this.searchPlace = this.geocodedLocation;
			this.addressSearch = this.searchPlace.name;
			this.map.isOpen = false;
		},

		setMarkerCoordsFromClick( { latLng } ) {
			this.placeIdToGeocode = null;
			this.map.markerCoords = latLng;
		},

		setMarkerCoordsFromSearch( place ) {
			this.placeIdToGeocode = place.place_id;
			this.map.markerCoords = {
				lat: place.latitude,
				lng: place.longitude
			};
		}
	},

	created() {
		if ( this.value ) {
			this.addressSearch = this.value;
		}

		if ( this.address && this.city && this.state && this.zip ) {
			this.addressSearch = `${this.address}, ${this.city}, ${this.state} ${this.zip}`;
		}
	},

	render() {
		return <KFullscreenDialog
			title={this.title}
			vModel={this.map.isOpen}
			scopedSlots={{
				activator: ( { on } ) => [
					<KGoogleAutocomplete
						clearable
						hideDetails
						onKeypress={e => {

							// Enter
							if ( e.keyCode === 13 ) {
								e.preventDefault();
							}
						}}
						label={this.label}
						onPlacechanged={place => this.searchPlace = place}
						prependIcon="search"
						types={null}
						vModel={this.addressSearch}
					>
						<VBtn
							on={on}
							slot="append-outer"
							small
							text
						>
							<VIcon left>map</VIcon> Map
						</VBtn>
					</KGoogleAutocomplete>
				]
			}}
		>
			<KGooglePlacesTextSearch
				class="mt-3"
				slot="toolbarExtension"
				clearable
				color="white"
				label="Location Search"
				onKeypress={e => {

					// Enter
					if ( e.keyCode === 13 ) {
						e.preventDefault();
					}
				}}
				onPlacechanged={this.setMarkerCoordsFromSearch}
				prependIcon="search"
				vModel={this.map.search}
			></KGooglePlacesTextSearch>

			<gmap-map
				center={this.map.center}
				onClick={this.setMarkerCoordsFromClick}
				options={this.map.options}
				ref="addressMap"
				style="height: 100%; width: 100%;"
				zoom={9}
			>
				<gmap-marker
					onClick={() => {
						this.map.infoWindow.isOpen = !this.map.infoWindow.isOpen;
					}}
					position={this.map.markerCoords}
				></gmap-marker>

				<gmap-info-window
					onCloseclick={() => {
						this.map.infoWindow.isOpen = false;
					}}
					opened={this.map.infoWindow.isOpen}
					options={this.map.infoWindow.options}
					position={this.map.markerCoords}
				>
					<h3 class="grey--text text--darken-4">{this.infoWindowTitle}</h3>

					<VBtn
						block
						class="mt-3"
						color="success"
						loading={this.geocoderRunning}
						onClick={this.useMapAddress}
					>
						<VIcon left>done</VIcon>
						Use This Address
					</VBtn>
				</gmap-info-window>
			</gmap-map>
		</KFullscreenDialog>;
	}
};
